import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.repair-suggestion',
    method: 'get',
    params,
  })
}

export const listAllRepairSuggestion = (params?: any) => {
  return axiosService({
    url: '/api.repair-suggestion/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.repair-suggestion/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}/apply`,
    method: 'put',
  })
}

export const process = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}/process`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}/remake`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.repair-suggestion/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.repair-suggestion',
    method: 'post',
    data,
  })
}
